<template>
<DemoBase size="xs4">
  <Button
    outlined block
    title="Open BottomSheet"
    @onClick="onButtonClick" />
  <BottomSheet
    @onClose="onBottomSheetClose"
    v-model="bottomSheet">
    Hello world
  </BottomSheet>
</DemoBase>
</template>

<script>
import DemoBase from "@/base_lib/demo/base/DemoBase"
import Button from "@/base_lib/components/form/Button"
import BottomSheet from "@/base_lib/components/container/BottomSheet"

export default {
  name: "BottomSheetDemo",
  components: {BottomSheet, Button, DemoBase},
  data: () => ({
    bottomSheet: false,
  }),
  methods: {
    onButtonClick() {
      this.bottomSheet = true
    },
    onBottomSheetClose() {
      this.bottomSheet = false
    },
  },
}
</script>

<style scoped>

</style>